import Icon from '@ant-design/icons';

const BarChartSvg = (props: any) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M2.5 13.5V2.5" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" />
    <path d="M2.5 13.5H13.5" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" />
    <rect x="4.75" y="8.25" width="2" height="3.75" rx="0.5" stroke="currentColor" strokeWidth="1.25" />
    <rect x="8.25" y="5.5" width="2" height="6.5" rx="0.5" stroke="currentColor" strokeWidth="1.25" />
    <rect x="11.75" y="3" width="2" height="9" rx="0.5" stroke="currentColor" strokeWidth="1.25" />
  </svg>
);

export const BarChartIcon = (props: any) => <Icon component={BarChartSvg} {...props} />;
